module.exports = __webpack_public_path__ + "img/po2.1e3c35e6.jpg";